import { Navigate } from "react-router-dom";
import { Typography as T, useTheme, useMediaQuery } from "@mui/material";
import ErrorPage from "../../../../components/ErrorPage";
import Loader from "../../../../components/Loader";
import useGetAccountStatus from "../../../../hooks/queries/employee/useGetAccountStatus";
import { employeeAccountPath } from "../../../../routes/paths";
import loginIcon from "../../../../assets/logos/login.svg";
import loginMobileIcon from "../../../../assets/logos/loginMobile.svg";
import {
  LoginGradient,
  LoginLogo,
  InnerNavContainer,
} from "../../../Auth/components";

const AccountStatus = () => {
  const { data, status } = useGetAccountStatus();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("tablet"));

  if (status === "loading") return <Loader text="Loading account..." />;
  if (status === "error") return <ErrorPage />;

  // handle active account
  if (data && data.status === "account_active") {
    return <Navigate to={employeeAccountPath} replace />;
  }

  // handle non active account
  return (
    <div
      style={{ display: "flex", flexDirection: isMobile ? "column" : "row" }}
    >
      {isMobile && (
        <LoginGradient>
          <LoginLogo src={loginMobileIcon} alt="logo" />
        </LoginGradient>
      )}
      <div style={{ flex: 2 }}>
        <InnerNavContainer>
          <T variant="headingMd">Your account is not active.</T>
          <T variant="mdReg">Please contact support with any questions.</T>
        </InnerNavContainer>
      </div>
      {!isMobile && (
        <LoginGradient>
          <LoginLogo src={loginIcon} alt="logo" />
        </LoginGradient>
      )}
    </div>
  );
};

export default AccountStatus;
